// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customer_confirm_page[data-v-7b2b9898]{background-color:#122333;padding-top:13px;padding-bottom:13px;height:100%}.customer_confirm_card[data-v-7b2b9898]{background-color:#fff}.customer_confirm_carousel[data-v-7b2b9898]{background-color:#122333}", ""]);
// Exports
module.exports = exports;
